import { render, staticRenderFns } from "./consumivel.vue?vue&type=template&id=547f2d99"
import script from "./consumivel.vue?vue&type=script&lang=js"
export * from "./consumivel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports